<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="источник"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getMarketingSource"
      :get-list="getItems"
      :can-create-catalog="canEditMarketingSource()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <marketing-source
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import MarketingSource from "./MarketingSource.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "MarketingSourceSelect",
  components: { MarketingSource, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getMarketingSources({});
      return (result && result.data && result.data.items) ? result.data.items : [];
    },
    async getMarketingSource(id) {
      const result = await this.getMarketingSourceById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditMarketingSource() {
      return this.hasPermission([PERM.CATALOG_SOURCE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/MarketingSources/MarketingSourceSelect.vue